import { useTranslation } from 'react-i18next';
import { ChevronLeft, HelpCircle, History, X } from 'lucide-react';
import { AmbossActionBar, AmbossIconButton, AmbossPanelTitle } from './amboss.styles';
import { useAmboss } from './useAmboss';

export function AmbossTitleBarContent() {
  const { t } = useTranslation();
  const { overlay, query, back, hideOverlay, showHelp, showHistory, close } = useAmboss();

  const title = query || t('amboss.searchPanel.title');
  const onBack = overlay !== 'none' ? hideOverlay : back;

  return (
    <>
      <div className="flex flex-1 items-center gap-2 min-w-0">
        <AmbossIconButton aria-label={t('amboss.actions.back')} onClick={onBack}>
          <ChevronLeft size={24} />
        </AmbossIconButton>
        <AmbossPanelTitle data-ph-no-autocapture>{title}</AmbossPanelTitle>
      </div>
      <AmbossActionBar>
        <AmbossIconButton
          aria-label={t('amboss.actions.history')}
          onClick={showHistory}
          $active={overlay === 'history'}
        >
          <History size={20} />
        </AmbossIconButton>
        <AmbossIconButton
          aria-label={t('amboss.actions.help')}
          onClick={showHelp}
          $active={overlay === 'help'}
        >
          <HelpCircle size={20} />
        </AmbossIconButton>
        <AmbossIconButton aria-label={t('amboss.actions.close')} onClick={close}>
          <X size={20} />
        </AmbossIconButton>
      </AmbossActionBar>
    </>
  );
}
